// Makhana (Fox Nuts) & Pulses catalogues — same schema as spices for reuse in ProductDetail
export const MAKHANA_PRODUCTS = [
  {
    slug: "premium-raw-makhana",
    name: "Premium Raw Makhana",
    tagline: "Euryale ferox · Fox Nuts",
    moq: "200 kg",
    grade: "5 Suta / 6 Suta / Handpicked",
    image: "/images/spices/premium-raw-makhana.png",
    color: "#E8DCC0",
    description: "Naturally sourced, sun-dried premium raw makhana pops from the pristine ponds of Bihar and eastern India. Hygienically cleaned, size-graded and moisture-controlled to deliver the largest, whitest and crunchiest fox nuts on the international market.",
    origin: "Darbhanga, Madhubani — Bihar, India",
    moisture: "≤ 6%",
    purity: "99% clean pops, moisture-controlled",
    curcumin: "—",
    shelf_life: "12 months from date of packaging",
    storage: "Cool, dry, moisture-free environment",
    packaging: "10kg / 20kg cartons with food-grade poly liner; retail packs on request",
    applications: ["Healthy snacking category", "Roasted / flavoured makhana brands", "Nutraceutical & protein-rich formulations", "Confectionery and dessert ingredients"],
  },
  {
    slug: "roasted-makhana",
    name: "Roasted Makhana",
    tagline: "Ready-to-eat · Multiple Flavours",
    moq: "100 kg",
    grade: "Retail Ready / Private Label",
    image: "/images/spices/roasted-makhana.png",
    color: "#D4B98A",
    description: "Slow-roasted in ghee, coconut or sunflower oil and seasoned in-house to deliver a light, airy crunch with clean-label flavour profiles. Available in Himalayan Pink Salt, Peri-Peri, Cheese, Tandoori Masala, Turmeric-Pepper and unflavoured variants — or custom-developed for your brand.",
    origin: "Sourced Bihar · Processed India",
    moisture: "≤ 4%",
    purity: "Certified food-safe seasoning, no preservatives",
    curcumin: "—",
    shelf_life: "9 months in sealed packaging",
    storage: "Cool, dry, sealed containers",
    packaging: "Nitrogen-flushed SUPs, PET jars, retail cartons — 25g to 200g formats; bulk 5kg foodservice packs",
    applications: ["Premium healthy-snack retail", "In-flight and hospitality snack service", "Gift-set and gourmet hampers", "Sports nutrition and lifestyle brands"],
  },
  {
    slug: "fox-nuts",
    name: "Fox Nuts",
    tagline: "Bulk Export Grade",
    moq: "500 kg",
    grade: "Export Bulk / Industrial",
    image: "/images/spices/fox-nuts.png",
    color: "#EFE4CB",
    description: "Bulk-grade fox nuts (makhana) supplied to international snack manufacturers, cereal formulators and private label brands. Sortex-cleaned, size-graded and packed in food-grade export cartons — ideal for buyers producing roasted, flavoured or ingredient-form fox nut products at scale.",
    origin: "Bihar & eastern India",
    moisture: "≤ 6%",
    purity: "Sortex cleaned, size graded 4 Suta – 7 Suta",
    curcumin: "—",
    shelf_life: "12 months",
    storage: "Cool, dry, ventilated warehouse",
    packaging: "10kg / 20kg cartons; 25kg PP bags with food-grade liner",
    applications: ["Snack manufacturing", "Breakfast cereal ingredient", "Bulk retail repackaging", "Ingredient supply to nutraceutical brands"],
  },
];

export const PULSES_PRODUCTS = [
  {
    slug: "toor-dal",
    name: "Toor Dal (Pigeon Pea)",
    tagline: "Cajanus cajan · Yellow Split",
    moq: "1000 kg",
    grade: "Sortex Cleaned, Polished / Unpolished",
    image: "/images/spices/toor-dal.png",
    color: "#E4B45A",
    description: "Golden-yellow split pigeon peas — the cornerstone of the Indian daily kitchen and increasingly popular across ethnic supermarkets worldwide. Sortex-cleaned, size-graded and available polished (oil / water) or unpolished per buyer preference.",
    origin: "Maharashtra, Karnataka, Madhya Pradesh — India",
    moisture: "≤ 12%",
    purity: "99.5% split, foreign matter ≤ 0.5%",
    curcumin: "—",
    shelf_life: "12 months",
    storage: "Cool, dry, well-ventilated",
    packaging: "25kg / 50kg PP bags with liner; retail 500g / 1kg packs on request",
    applications: ["Ethnic supermarket retail", "Foodservice & industrial dal manufacturers", "Ready-to-eat & instant dal brands", "Vegetarian protein formulations"],
  },
  {
    slug: "chana-dal",
    name: "Chana Dal (Split Bengal Gram)",
    tagline: "Cicer arietinum · Split, Husked",
    moq: "1000 kg",
    grade: "Sortex Cleaned, Machine Polished",
    image: "/images/spices/chana-dal.png",
    color: "#D9A548",
    description: "Split and husked Bengal gram with a rich yellow hue and nutty flavour. A staple protein source for South Asian cuisine and increasingly used in gluten-free flours, snacks and plant-protein products worldwide.",
    origin: "Madhya Pradesh, Rajasthan, Maharashtra — India",
    moisture: "≤ 12%",
    purity: "99% split, uniform size",
    curcumin: "—",
    shelf_life: "12 months",
    storage: "Cool, dry environment",
    packaging: "25kg / 50kg PP bags; retail 500g / 1kg / 5kg packs available",
    applications: ["Retail dal brands", "Besan (gram flour) manufacturers", "Snack formulations (namkeen, sev)", "Plant-based protein products"],
  },
  {
    slug: "moong-dal",
    name: "Moong Dal (Split Green Gram)",
    tagline: "Vigna radiata · Split, Husked",
    moq: "1000 kg",
    grade: "Sortex Cleaned, Polished / Unpolished",
    image: "/images/spices/moong-dal.png",
    color: "#EDCB4A",
    description: "Split and husked green gram delivering a light-yellow, quick-cooking dal beloved for its digestibility. Available split-with-skin (Chilka) or split-without-skin (Dhuli) formats.",
    origin: "Rajasthan, Andhra Pradesh, Maharashtra — India",
    moisture: "≤ 12%",
    purity: "99% split, foreign matter ≤ 0.5%",
    curcumin: "—",
    shelf_life: "12 months",
    storage: "Cool, dry, sealed",
    packaging: "25kg / 50kg PP bags; retail packs on request",
    applications: ["Retail dal brands", "Baby food and khichdi formulations", "Sprouts and salad ingredients", "Ayurvedic and health-food products"],
  },
  {
    slug: "urad-dal",
    name: "Urad Dal (Split Black Gram)",
    tagline: "Vigna mungo · Split, Husked",
    moq: "1000 kg",
    grade: "Sortex Cleaned, Polished",
    image: "/images/spices/urad-dal.png",
    color: "#F0EBD8",
    description: "Cream-white split black gram — the essential ingredient behind South Indian idli, dosa and vada batters, and a critical protein staple across the subcontinent. Available with or without husk.",
    origin: "Andhra Pradesh, Maharashtra, Tamil Nadu — India",
    moisture: "≤ 12%",
    purity: "99% split, uniform texture",
    curcumin: "—",
    shelf_life: "12 months",
    storage: "Cool, dry, ventilated",
    packaging: "25kg / 50kg PP bags with liner",
    applications: ["Idli / dosa batter manufacturers", "Retail dal brands", "Papad and vada mix formulations", "Ready-to-eat South Indian foods"],
  },
  {
    slug: "masoor-dal",
    name: "Masoor Dal (Red Lentils)",
    tagline: "Lens culinaris · Split / Whole",
    moq: "1000 kg",
    grade: "Sortex Cleaned, Bold / Small",
    image: "/images/spices/masoor-dal.png",
    color: "#D97542",
    description: "Vibrant orange-red lentils — split masoor for quick-cook Indian dals and whole masoor for European soups and stews. High-protein, quick-cooking and one of the fastest-growing categories in international ethnic retail.",
    origin: "Madhya Pradesh, Uttar Pradesh, Bihar — India",
    moisture: "≤ 12%",
    purity: "99.5% clean, uniform colour",
    curcumin: "—",
    shelf_life: "12 months",
    storage: "Cool, dry place",
    packaging: "25kg / 50kg PP bags; retail 500g / 1kg on request",
    applications: ["Retail lentil brands (Europe & Middle East)", "Soup and stew ingredient manufacturers", "Ready-to-eat dal / lentil pouches", "Plant-protein and vegan meal kits"],
  },
  {
    slug: "kabuli-chickpeas",
    name: "Kabuli Chickpeas",
    tagline: "Cicer arietinum · Whole, White",
    moq: "1000 kg",
    grade: "42 / 44 / 58 count per oz",
    image: "/images/spices/kabuli-chickpeas.png",
    color: "#DEC38A",
    description: "Large, cream-white Kabuli chickpeas graded by count-per-ounce for consistency across every 25kg bag. The base ingredient for hummus, canned chickpeas, roasted snacks and chickpea flour worldwide.",
    origin: "Madhya Pradesh, Maharashtra, Karnataka — India",
    moisture: "≤ 12%",
    purity: "Sortex cleaned, size-uniform",
    curcumin: "—",
    shelf_life: "18 months",
    storage: "Cool, dry warehouse",
    packaging: "25kg / 50kg PP bags; big-bag 1MT jumbo available",
    applications: ["Hummus and dip manufacturers", "Canned chickpea brands", "Roasted / flavoured chickpea snacks", "Chickpea flour (besan alternative) and plant-protein products"],
  },
  {
    slug: "green-moong",
    name: "Green Moong (Whole Green Gram)",
    tagline: "Vigna radiata · Whole",
    moq: "1000 kg",
    grade: "SQ / Bold / Special",
    image: "/images/spices/green-moong.png",
    color: "#4E7A38",
    description: "Whole green mung beans — one of the world's fastest-growing plant-protein categories. Bright green, uniform size, ideal for sprouting, cooking, and increasingly used in vegan protein powders and meat-alternative formulations.",
    origin: "Rajasthan, Maharashtra, Andhra Pradesh — India",
    moisture: "≤ 12%",
    purity: "99.5% clean, sortex sorted",
    curcumin: "—",
    shelf_life: "18 months",
    storage: "Cool, dry, ventilated",
    packaging: "25kg / 50kg PP bags",
    applications: ["Sprouting industry", "Vegan protein and meat-alternative brands", "Retail whole-pulse packaging", "Ayurvedic and health-food formulations"],
  },
  {
    slug: "black-gram",
    name: "Black Gram (Whole Urad)",
    tagline: "Vigna mungo · Whole, Unpolished",
    moq: "1000 kg",
    grade: "Sortex Cleaned",
    image: "/images/spices/black-gram.png",
    color: "#1E1A16",
    description: "Small, deep-black whole urad beans — the base ingredient for iconic Indian dishes like dal makhani and countless regional preparations. Sortex-cleaned to remove stones and foreign matter.",
    origin: "Andhra Pradesh, Madhya Pradesh, Tamil Nadu — India",
    moisture: "≤ 12%",
    purity: "99.5% clean",
    curcumin: "—",
    shelf_life: "18 months",
    storage: "Cool, dry environment",
    packaging: "25kg / 50kg PP bags with liner",
    applications: ["Dal makhani ready-mix brands", "Retail whole-pulse packaging", "Papad and idli / dosa manufacturers", "Ethnic supermarket private label"],
  },
  {
    slug: "yellow-peas",
    name: "Yellow Peas",
    tagline: "Pisum sativum · Whole / Split",
    moq: "1000 kg",
    grade: "Sortex Cleaned, Bold",
    image: "/images/spices/yellow-peas.png",
    color: "#D9AE3F",
    description: "Whole and split yellow peas — a rising star in the global plant-protein economy, used in pea protein isolate, meat alternatives, and traditional dal and soup formats.",
    origin: "Madhya Pradesh, Uttar Pradesh — India (and origin sourcing)",
    moisture: "≤ 12%",
    purity: "99.5% clean, uniform size",
    curcumin: "—",
    shelf_life: "18 months",
    storage: "Cool, dry warehouse",
    packaging: "25kg / 50kg PP bags",
    applications: ["Pea protein isolate manufacturers", "Plant-based meat alternatives", "Retail dal and soup brands", "Foodservice ingredient supply"],
  },
  {
    slug: "white-peas",
    name: "White Peas",
    tagline: "Pisum sativum · Whole",
    moq: "1000 kg",
    grade: "Sortex Cleaned",
    image: "/images/spices/white-peas.png",
    color: "#EFE7CE",
    description: "Cream-white whole peas — a versatile pulse used in traditional Indian snacks (chana masala), ragda-pattice, and increasingly in Western vegan formulations and snacking categories.",
    origin: "Uttar Pradesh, Madhya Pradesh — India",
    moisture: "≤ 12%",
    purity: "99.5% clean",
    curcumin: "—",
    shelf_life: "18 months",
    storage: "Cool, dry environment",
    packaging: "25kg / 50kg PP bags",
    applications: ["Snack manufacturers (roasted / flavoured)", "Ragda-pattice and chaat mix brands", "Retail whole-pulse packaging", "Ingredient supply to plant-protein brands"],
  },
  {
    slug: "kidney-beans",
    name: "Kidney Beans (Rajma)",
    tagline: "Phaseolus vulgaris · Light / Dark Red",
    moq: "1000 kg",
    grade: "Jammu / Chitra / Dark Red",
    image: "/images/spices/kidney-beans.png",
    color: "#8E2A20",
    description: "Deep-red kidney beans — from the celebrated Jammu Rajma variety (small, aromatic) to the bold Dark Red kidney bean prized in Latin American and North American cuisines. Sortex-cleaned and size-graded.",
    origin: "Jammu, Himachal Pradesh, Karnataka — India",
    moisture: "≤ 14%",
    purity: "99.5% clean, uniform size and colour",
    curcumin: "—",
    shelf_life: "18 months",
    storage: "Cool, dry, sealed",
    packaging: "25kg / 50kg PP bags; retail 500g / 1kg on request",
    applications: ["Retail bean brands (North America, Europe)", "Canned bean manufacturers", "Rajma / chilli / stew ready-mix brands", "Foodservice supply"],
  },
];

// Utility to look up any product across all catalogues
import { PRODUCTS as SPICE_PRODUCTS } from "./products";

export const ALL_CATALOGUES = {
  spice: { products: SPICE_PRODUCTS, base: "/products", label: "Spices" },
  makhana: { products: MAKHANA_PRODUCTS, base: "/makhana", label: "Makhana" },
  pulses: { products: PULSES_PRODUCTS, base: "/pulses", label: "Pulses" },
};

export function findAnyProduct(slug) {
  for (const [cat, { products, base, label }] of Object.entries(ALL_CATALOGUES)) {
    const p = products.find((x) => x.slug === slug);
    if (p) return { product: p, category: cat, base, label, siblings: products };
  }
  return null;
}
